import type { TenantStatus } from '../types/tenant.types';

type DisplayTenantStatus =
  | TenantStatus
  | 'suspended'
  | 'pending';


export interface TenantStatusBadgeProps {
  status: DisplayTenantStatus;
}


const STATUS_LABEL: Record<DisplayTenantStatus, string> = {
  active: 'فعال',
  inactive: 'غیرفعال',
  suspended: 'تعلیق شده',
  pending: 'در انتظار',
};


const STATUS_COLOR_VAR: Record<DisplayTenantStatus, string> = {
  active: 'var(--vania-accent-teal, #2fd6a7)',
  inactive: 'var(--vania-accent-rose, #ff6b81)',
  suspended: 'var(--vania-accent-rose, #ff6b81)',
  pending: 'var(--vania-accent-amber, #f5b942)',
};


export function TenantStatusBadge({
  status,
}: TenantStatusBadgeProps) {

  const color = STATUS_COLOR_VAR[status];


  return (
    <span
      className="vania-tenant-status-badge"
      style={{
        color,
        borderColor: color,
      }}
    >
      <span
        aria-hidden
        className="vania-tenant-status-dot"
        style={{
          backgroundColor: color,
        }}
      />

      {STATUS_LABEL[status]}

    </span>
  );
}
